var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGoml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GOMLVL_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.053,
    height: 39.666,
    viewBox: "0 0 25.053 39.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_21",
    "data-name": "Rechteck 21",
    width: 25.053,
    height: 39.666,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_22",
    "data-name": "Gruppe 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_21",
    "data-name": "Gruppe 21",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_53",
    "data-name": "Pfad 53",
    d: "M20.976,246.5l.6-.267a1.088,1.088,0,0,0,.651-.951c0-.413,0-2.616,0-2.616l1.2-4.6-1.272.567-.67,2.665-.869-1.977-1.155.5,1.515,3.366ZM2,252.975A1.228,1.228,0,0,0,3.4,254.2a2.247,2.247,0,0,0,2.051-2.025c0-1,0-3.423,0-4.244a1.234,1.234,0,0,0-1.534-1.2A2.239,2.239,0,0,0,2,248.954c0,1.12.006,3.272.006,4.022m5.829-8.01c-.79.35-1.177.592-1.177,1.159,0,.656.016,6.5.016,6.692,1.162-.507,1.162-.507,1.162-1.552s0-2.719,0-2.719l.11-.046,1.146,3.252c1.163-.514,1.163-.514,1.16-1.571v-6.288s-.444.2-.444.193a1.017,1.017,0,0,0-.724.891c0,.445.008,3.126.008,3.472l-.072.021c-.447-1.127-.727-2.349-1.186-3.5m7.251-3.209c-.365.156-.575.251-.991.434a.961.961,0,0,0-.622.885c0,.335,0,6.737,0,6.737s.557-.237.837-.368.431-.374.431-.857v-3.755l.121-.056,1.2,3.9.711-.318.856-4.79.125-.061,0,4.418.8-.34a.877.877,0,0,0,.443-.831v-6.71l-.866.374a1.685,1.685,0,0,0-1.2,1.3c-.187.857-.655,2.577-.655,2.577s-.985-2.077-1.179-2.536M.05,256.944s0-8.365,0-8.958a1.112,1.112,0,0,1,.759-1.158c7.948-3.518,24.277-10.762,24.277-10.762s0,7.479,0,8.612a1.672,1.672,0,0,1-.729,1.52Z",
    transform: "translate(-0.047 -223.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_54",
    "data-name": "Pfad 54",
    d: "M4.3,91.532l-.986.22V89.7a.474.474,0,0,1,.42-.469S6.978,88.5,6.978,88.5v6.307A1.179,1.179,0,0,1,6.209,96s-3.337,1.483-5,2.211C0,98.682,0,97.025,0,96.744,0,92.767,0,86.044,0,84.813a5.059,5.059,0,0,1,1.2-3.476A4.147,4.147,0,0,1,4.84,80.009,2.345,2.345,0,0,1,6.978,82.47c0,1.1,0,2.795,0,3.044a.5.5,0,0,1-.4.544l-2.282.5s0-2.685,0-3.062a.765.765,0,0,0-.579-.843.785.785,0,0,0-.939.568,3.712,3.712,0,0,0-.093.844s-.006.011-.006,11.12c0,.632.216,1,.655,1.007a.937.937,0,0,0,.951-1.019c0-.6,0-3.644,0-3.644",
    transform: "translate(0 -75.624)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_24",
    "data-name": "Gruppe 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_23",
    "data-name": "Gruppe 23",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_55",
    "data-name": "Pfad 55",
    d: "M170.1,48.659l-5.99,2.647s.01-10.217.01-15.012c0-.755.027-.955.752-1.125.141-.034,5.227-1.182,5.227-1.182s0,2.138,0,2.582c0,.382-.346.441-.57.489s-2.733.615-2.733.615v3.588l2.422-.559s0,.925,0,2.241c0,.723-.526.818-.526.818l-1.9.434.006,4.024,3.3-.74Z",
    transform: "translate(-155.16 -32.134)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_56",
    "data-name": "Pfad 56",
    d: "M287.952,4.089s-1.66.379-2.5.563c0-.873.007-2.235.007-2.5s.16-.458.522-.532S292.261.206,293.145,0c0,.544,0,1.926,0,2.3a.716.716,0,0,1-.612.767c-.464.107-1.984.447-1.984.447s0,9.4,0,9.766a.892.892,0,0,1-.536.959c-.492.216-1.334.594-2.06.913Z",
    transform: "translate(-269.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_57",
    "data-name": "Pfad 57",
    d: "M210.02,494.018l.657,4.365.11-.048.763-5,2.317-1.02L211.92,505.14h-2.236l-1.736-10.21Z",
    transform: "translate(-196.611 -465.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_58",
    "data-name": "Pfad 58",
    d: "M81.072,578.413v6.075l2.743,0a.373.373,0,0,1,.39.384v1.673H78.749s0-5.817,0-6.342a1.055,1.055,0,0,1,.68-1.058c.507-.229,1.645-.73,1.645-.73",
    transform: "translate(-74.454 -546.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_59",
    "data-name": "Pfad 59",
    d: "M351.71,459.157v12.577l2.743,0a.373.373,0,0,1,.39.384v1.673h-5.456s0-12.318,0-12.844a1.055,1.055,0,0,1,.68-1.058c.507-.229,1.645-.73,1.645-.73",
    transform: "translate(-330.336 -434.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_60",
    "data-name": "Pfad 60",
    d: "M3.359,605.34v2.824L.05,606.794Z",
    transform: "translate(-0.048 -572.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_61",
    "data-name": "Pfad 61",
    d: "M403.629,195.665l-3.223,1.431v-2.9Z",
    transform: "translate(-378.575 -183.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_62",
    "data-name": "Pfad 62",
    d: "M1.256,181.953c-1.206.468-1.206-1.2-1.206-1.47V168.552",
    transform: "translate(-0.047 -159.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_63",
    "data-name": "Pfad 63",
    d: "M78.749,599.209s0-6.338,0-6.342a1.055,1.055,0,0,1,.68-1.058",
    transform: "translate(-74.454 -559.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_64",
    "data-name": "Pfad 64",
    d: "M58.912,455.209a.372.372,0,0,0-.462-.362.675.675,0,0,0-.579.671c0,.337,0,3.837,0,4.063a.37.37,0,0,0,.42.368.677.677,0,0,0,.618-.61c0-.3,0-3.883,0-4.13",
    transform: "translate(-54.716 -430.042)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoml);
export default __webpack_public_path__ + "static/media/logo_goml.891fa004c1296eed147ac954cad2a037.svg";
export { ForwardRef as ReactComponent };